import React from 'react';

import Link from '../../../../library/link/link';
import ProductArticleStatusLabel from '../../../../components/product-article-status-label/product-article-status-label';
import { TagsSolidIcon } from '../../../../shared/icons/icons';

import {
  removeStoredBackToResultsUrl,
  setStoredBackToResultsUrl
} from '../../../../shared/utils/back-to-results/back-to-results';
import {
  getFallbackProductImageUrl,
  getProductImage,
  getShouldShowProductArticleStatusLabel
} from '../../../../shared/utils/product/product';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import {
  ArticleAvailiabityStatusEnum,
  ProductData,
  ProductType
} from '../../../../shared/types/graphql-types';
import { BACK_TO_RESULTS_PAGE_IDS } from '../../../../shared/constants/back-to-results';
import { PRODUCT_IMAGE_FORMATS } from '../../../../shared/constants/product-images';

import './product-list-item.scss';

export const MORE_OPTIONS_TEXT = 'more colors/finishes available';

interface ProductImage {
  altText?: string;
  url?: string;
}

interface Product {
  articleStatus?: ArticleAvailiabityStatusEnum;
  code: string;
  name: string;
  potentialPromotions?: ProductData['potentialPromotions'];
  swatches: ProductData['swatches'];
  url: string;
}

interface ProductListItemProps {
  product: Product;
  productType: ProductType;
}

function ProductListItem(props: ProductListItemProps) {
  const { product, productType } = props;
  const { swatches } = product;
  const handleClick = () => {
    removeStoredBackToResultsUrl();
    setStoredBackToResultsUrl(BACK_TO_RESULTS_PAGE_IDS.CATEGORY);
  };

  const image: ProductImage =
    getProductImage(product, {
      format: PRODUCT_IMAGE_FORMATS.PRODUCT,
      shouldFallBackToFirst: true
    }) || {};

  const productImageSrc = image.url?.includes('cdn.discounttire.com/')
    ? image.url
    : getFallbackProductImageUrl(productType);
  const shouldShowProductArticleStatusLabel =
    getShouldShowProductArticleStatusLabel(product.articleStatus);

  return (
    <div styleName="product">
      <div>
        <Link onClick={handleClick} to={product.url}>
          <img
            alt={image.altText || product.code}
            draggable={false}
            height={180}
            src={productImageSrc}
            styleName="image"
            width={180}
          />
        </Link>
      </div>
      <div styleName="center">
        {shouldShowProductArticleStatusLabel && (
          <ProductArticleStatusLabel
            articleStatus={
              product.articleStatus || ArticleAvailiabityStatusEnum.A
            }
          />
        )}

        <Link onClick={handleClick} styleName="link" to={product.url}>
          {Array.isArray(product.potentialPromotions) &&
            product.potentialPromotions.length > 0 && (
              <TagsSolidIcon styleName="promo" />
            )}
          {product.name}
        </Link>
        {isArrayWithLength(swatches) && (
          <p styleName="more-options-message">{MORE_OPTIONS_TEXT}</p>
        )}
      </div>
    </div>
  );
}

export default ProductListItem;
